
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.656 8.125c-1.083 0-1.911-.318-2.484-.953C.604 6.532.32 5.586.32 4.336c0-.86.149-1.586.446-2.18.302-.594.713-1.034 1.234-1.32C2.52.544 3.115.398 3.781.398c1.115 0 1.959.326 2.531.977.573.646.86 1.576.86 2.79 0 .864-.143 1.593-.43 2.187-.286.593-.693 1.039-1.219 1.335-.526.292-1.148.438-1.867.438zm-1.86-3.953c0 1.073.17 1.898.509 2.476.343.573.833.86 1.468.86.35 0 .646-.084.891-.25.245-.172.443-.401.594-.688.156-.286.268-.617.336-.992.067-.38.101-.776.101-1.187 0-.766-.086-1.401-.258-1.907-.166-.505-.395-.875-.687-1.109a1.531 1.531 0 00-1-.36c-.63 0-1.115.274-1.453.82-.333.548-.5 1.326-.5 2.337z","fill":"currentColor"}})])
          )
        }
      }
    